export enum PhaseSlotChangeReasonActionTypes {
	CancelSlot = "CancelSlot",
	CancelSlotExwork = "CancelSlotExwork",
	CancelSlotDriver = "CancelSlotDriver",
	SetSlot = "SetSlot",
	SetSlotExwork = "SetSlotExwork",
	SetSlotDriver = "SetSlotDriver",
	SwapSlot = "SwapSlot",
	ObtainSlot = "ObtainSlot",
	MoveSlot = "MoveSlot",
	ReserveOutOfHours = "ReserveOutOfHours",
	None = "None"
}
